import _readOnlyError from "@babel/runtime/helpers/readOnlyError";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import TextareaAutosize from 'react-autosize-textarea';
import Select from 'react-select';
import { formatCurrencyPlain } from '../../../numberUtils';
import { postRequest, putRequest } from '../../../requestUtils';
import calender from '../../../../assets/images/icons/calender.svg';
import dollar from '../../../../assets/images/icons/dollar.svg';
import './AdHocInvoiceModal.scss';
var validateFormInputs = function validateFormInputs(invoiceDate, invoiceBy, grossRevenue, consultantPayout, invoiceDescription) {
  var errors = {};
  var inputs = [{
    name: 'invoiceDate',
    value: invoiceDate
  }, {
    name: 'invoiceBy',
    value: invoiceBy
  }, {
    name: 'grossRevenue',
    value: grossRevenue
  }, {
    name: 'consultantPayout',
    value: consultantPayout
  }, {
    name: 'invoiceDescription',
    value: invoiceDescription
  }];
  inputs.forEach(function (input) {
    if (!input.value) {
      errors[input.name] = 'Required';
    }
  });
  return errors;
};
var formData = function formData(invoiceDate, invoiceBy, grossRevenue, consultantPayout, quickbooksInvoiceId, invoiceDescription, projectId) {
  return {
    invoice_date: invoiceDate,
    invoice_by: invoiceBy.value,
    gross_revenue: grossRevenue.replace(/,/, '') * 100,
    consultant_payout: consultantPayout.replace(/,/, '') * 100,
    quickbooks_invoice_id: quickbooksInvoiceId,
    invoice_description: invoiceDescription,
    project_id: projectId
  };
};
var initializeFormState = function initializeFormState() {
  var invoice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    showModal: false,
    invoiceDate: invoice !== null && invoice !== void 0 && invoice.invoice_date ? new Date(invoice.invoice_date) : null,
    invoiceBy: (invoice === null || invoice === void 0 ? void 0 : invoice.invoice_by) || '',
    grossRevenue: formatCurrencyPlain(((invoice === null || invoice === void 0 ? void 0 : invoice.gross_revenue) || 0) / 100),
    consultantPayout: formatCurrencyPlain(((invoice === null || invoice === void 0 ? void 0 : invoice.consultant_payout) || 0) / 100),
    quickbooksInvoiceId: (invoice === null || invoice === void 0 ? void 0 : invoice.quickbooks_invoice_id) || '',
    invoiceDescription: (invoice === null || invoice === void 0 ? void 0 : invoice.invoice_description) || '',
    isProcessing: false,
    errors: {}
  };
};
var AdHocInvoiceModal = /*#__PURE__*/function (_Component) {
  function AdHocInvoiceModal(props) {
    var _this;
    _classCallCheck(this, AdHocInvoiceModal);
    _this = _callSuper(this, AdHocInvoiceModal, [props]);
    var invoice = props.invoice;
    _this.state = _objectSpread({
      formMode: props.formMode
    }, initializeFormState(invoice));
    _this.open = _this.open.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
    return _this;
  }
  _inherits(AdHocInvoiceModal, _Component);
  return _createClass(AdHocInvoiceModal, [{
    key: "open",
    value: function open() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "close",
    value: function close() {
      var formMode = this.props.formMode;
      if (formMode === 'create') {
        this.setState(_objectSpread({}, initializeFormState()));
      } else {
        this.setState({
          showModal: false
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(name, value) {
      var errors = this.state.errors;
      var newErrors = _objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, name, ''));
      this.setState(_defineProperty(_defineProperty({}, name, value), "errors", newErrors));
    }
  }, {
    key: "handleCurrentInputFormat",
    value: function handleCurrentInputFormat(name, value) {
      if (formatCurrencyPlain(value) === 'NaN') {
        this.setState(_defineProperty({}, name, ''));
      } else {
        this.setState(_defineProperty({}, name, formatCurrencyPlain(value)));
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$state = this.state,
        invoiceDate = _this$state.invoiceDate,
        invoiceBy = _this$state.invoiceBy,
        grossRevenue = _this$state.grossRevenue,
        consultantPayout = _this$state.consultantPayout,
        quickbooksInvoiceId = _this$state.quickbooksInvoiceId,
        invoiceDescription = _this$state.invoiceDescription,
        formMode = _this$state.formMode;
      var _this$props = this.props,
        adHocInvoicesUrl = _this$props.adHocInvoicesUrl,
        csrfToken = _this$props.csrfToken,
        projectId = _this$props.projectId,
        invoice = _this$props.invoice;
      var errors = validateFormInputs(invoiceDate, invoiceBy, grossRevenue, consultantPayout, invoiceDescription);
      if (Object.keys(errors).length !== 0) {
        this.setState({
          errors: errors
        });
        return;
      }
      var params = formData(invoiceDate, invoiceBy, grossRevenue, consultantPayout, quickbooksInvoiceId, invoiceDescription, projectId);
      this.setState({
        isProcessing: true,
        processingError: ''
      });
      if (formMode === 'create') {
        postRequest(adHocInvoicesUrl, params, csrfToken).then(function () {
          _this2.close();
          window.location.reload();
        })["catch"](function () {
          _this2.setState({
            isProcessing: false,
            processingError: 'There an error processing your request try again later'
          });
        });
      } else {
        putRequest("".concat(adHocInvoicesUrl, "/").concat(invoice.resource_id), params, csrfToken).then(function () {
          _this2.close();
          window.location.reload();
        })["catch"](function () {
          _this2.setState({
            isProcessing: false,
            processingError: 'There an error processing your request try again later'
          });
        });
      }
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      var handleDelete = this.props.handleDelete;
      handleDelete();
    }
  }, {
    key: "handleOnKeyDown",
    value: function handleOnKeyDown(event) {
      if (event.keyCode === 32) {
        event.stopPropagation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        triggerText = _this$props2.triggerText,
        modalHeader = _this$props2.modalHeader,
        companyName = _this$props2.companyName,
        projectName = _this$props2.projectName,
        consultantFullName = _this$props2.consultantFullName;
      var _this$state2 = this.state,
        showModal = _this$state2.showModal,
        invoiceBy = _this$state2.invoiceBy,
        invoiceDate = _this$state2.invoiceDate,
        grossRevenue = _this$state2.grossRevenue,
        formMode = _this$state2.formMode,
        isProcessing = _this$state2.isProcessing,
        consultantPayout = _this$state2.consultantPayout,
        quickbooksInvoiceId = _this$state2.quickbooksInvoiceId,
        invoiceDescription = _this$state2.invoiceDescription,
        errors = _this$state2.errors,
        processingError = _this$state2.processingError;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "ad-hoc-trigger-button",
        onClick: this.open
      }, triggerText), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        id: "",
        dialogClassName: "ad-hoc-invoice-modal",
        onHide: this.open,
        onEscapeKeyDown: this.open,
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        onClick: this.close,
        role: "button",
        tabIndex: 0,
        className: "close-modal"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-times fa-lg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, modalHeader), /*#__PURE__*/React.createElement("div", {
        className: "sub-header"
      }, "Create a new invoice that cannot be billed via timesheet, e.g. FTE conversion fee, early termination fee, etc."), /*#__PURE__*/React.createElement("div", {
        className: "invoice-info"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "invoice-info-item"
      }, /*#__PURE__*/React.createElement("li", null, "Client:", /*#__PURE__*/React.createElement("strong", null, companyName)), /*#__PURE__*/React.createElement("li", null, "Project:", ' ', /*#__PURE__*/React.createElement("strong", null, projectName)), /*#__PURE__*/React.createElement("li", null, "Consultant Name:", /*#__PURE__*/React.createElement("strong", null, consultantFullName)))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-two"
      }, /*#__PURE__*/React.createElement("div", {
        className: " me-5"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "invoice-date"
      }, "Invoice Date"), /*#__PURE__*/React.createElement("div", {
        className: "input-with-symbol"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-3",
        src: calender,
        alt: "calender sign"
      }), /*#__PURE__*/React.createElement(DatePicker, {
        selected: invoiceDate,
        onChange: function onChange(date) {
          return _this3.handleChange('invoiceDate', date);
        },
        name: "invoice-date",
        placeholderText: "mm/dd/yyyy"
      })), errors.invoiceDate && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, errors.invoiceDate)), /*#__PURE__*/React.createElement("div", {
        className: ""
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "invoice-by"
      }, "Invoice By"), /*#__PURE__*/React.createElement(Select, {
        value: invoiceBy,
        onChange: function onChange(event) {
          return _this3.handleChange('invoiceBy', event);
        },
        options: [{
          value: 'clora',
          label: 'Clora'
        }, {
          value: 'consultant',
          label: 'Consultant'
        }],
        className: "invoice-by",
        name: "invoice-by",
        id: "invoice-by",
        placeholder: "Select one"
      }), errors.invoiceBy && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, errors.invoiceBy))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-two"
      }, /*#__PURE__*/React.createElement("div", {
        className: "me-5"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "gross-revenue"
      }, "Gross Revenue"), /*#__PURE__*/React.createElement("div", {
        className: "input-with-symbol"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-3",
        src: dollar,
        alt: "dollar sign"
      }), /*#__PURE__*/React.createElement("input", {
        type: "text",
        onChange: function onChange(event) {
          return _this3.handleChange('grossRevenue', event.target.value);
        },
        onBlur: function onBlur(event) {
          return _this3.handleCurrentInputFormat('grossRevenue', event.target.value);
        },
        value: grossRevenue,
        name: "gross-revenue",
        id: "gross-revenue",
        placeholder: "99,999.00"
      })), errors.grossRevenue && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, errors.grossRevenue)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        htmlFor: "consultant-payout"
      }, "Consultant Payout (excluding non-revenue)"), /*#__PURE__*/React.createElement("div", {
        className: "input-with-symbol"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pe-3",
        src: dollar,
        alt: "dollar sign"
      }), /*#__PURE__*/React.createElement("input", {
        type: "text",
        onChange: function onChange(event) {
          return _this3.handleChange('consultantPayout', event.target.value);
        },
        onBlur: function onBlur(event) {
          return _this3.handleCurrentInputFormat('consultantPayout', event.target.value);
        },
        value: consultantPayout,
        name: "consultant-payout",
        id: "consultant-payout",
        placeholder: "99,999.00"
      })), errors.consultantPayout && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, errors.consultantPayout))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-single"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "quickbooks-id"
      }, "QuickBooks Invoice ID"), /*#__PURE__*/React.createElement("input", {
        type: "text",
        onChange: function onChange(event) {
          return _this3.handleChange('quickbooksInvoiceId', event.target.value);
        },
        onKeyDown: function onKeyDown(event) {
          return _this3.handleOnKeyDown(event);
        },
        value: quickbooksInvoiceId,
        placeholder: "Enter an invoice ID, if available",
        className: "quickbooks-id",
        name: "quickbooks-id",
        id: "quickbooks-id"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-single"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "invoice-description"
      }, "Invoice Description"), /*#__PURE__*/React.createElement(TextareaAutosize, {
        value: invoiceDescription,
        rows: 3,
        maxRows: 5,
        onChange: function onChange(event) {
          return _this3.handleChange('invoiceDescription', event.target.value);
        },
        onKeyDown: function onKeyDown(event) {
          return _this3.handleOnKeyDown(event);
        },
        className: "invoice-description",
        name: "invoice-description"
      }), errors.invoiceDescription && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, errors.invoiceDescription))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement("div", {
        className: "form-actions mb-2"
      }, formMode === 'Edit' && /*#__PURE__*/React.createElement("button", {
        className: "btn-delete",
        onClick: this.handleDelete
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash-alt mr-3"
      }), "Delete Invoice"), /*#__PURE__*/React.createElement("button", {
        className: "btn-cancel",
        onClick: this.close
      }, "Cancel"), /*#__PURE__*/React.createElement("button", {
        className: "btn-save",
        onClick: this.handleSubmit
      }, isProcessing ? 'Saving...' : 'Save')), processingError && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, processingError))));
    }
  }]);
}(Component);
AdHocInvoiceModal.propTypes = {
  triggerText: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  formMode: PropTypes.string,
  modalHeader: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  consultantFullName: PropTypes.string.isRequired,
  adHocInvoicesUrl: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  invoice: PropTypes.shape({}),
  handleDelete: PropTypes.func
};
AdHocInvoiceModal.defaultProps = {
  triggerText: 'Create Ad-Hoc invoice',
  formMode: 'create',
  modalHeader: 'New Ad-Hoc Invoice',
  handleDelete: function handleDelete() {},
  invoice: {}
};
export default AdHocInvoiceModal;